import React, { Component } from "react";
import { connect } from "react-redux";

import { setPopup, setMenuState } from "../actions/siteActions";
import Bucket from "./Bucket";
import Popup from "./Popup";

class MainMenu extends Component {
  handleClick = (e) => {
    this.setMenuState();
  };

  setMenuState = () => {
    this.props.setMenuState(false);
  };

  createCategoryPrintButtons = () => {
    const { site } = this.props;

    return Object.keys(site.categories).map((cat, i) => {
      return (
        <li key={i}>
          <a
            onClick={this.handleClick}
            style={{ backgroundColor: site.categories[cat].acf.varvus }}
            className="button"
            href={site.pdfUrl + "test.php?category=" + site.categories[cat].id}
          
            target="_blank"
            rel="noopener noreferrer"
          >
            {site.categories[cat].name}
          </a>
        </li>
      );
    });
  };

  handleClickRequest = () => {
    this.setMenuState();
    this.props.setPopup("request-products", true);
  };
  /*
  printFullPdf = () =>{
    https://eestipagar.ee/ep_catalog/pdfgen/test.php
  }
*/
  render() {
    const { site } = this.props;
    const bucketLength = Object.keys(site.bucket).length;
    return (
      <div className="dropdown">
        <a
          onClick={this.handleClick}
          className="button"
          href={site.pdfUrl + "test.php"}
       
          target="_blank"
          rel="noopener noreferrer"
        >
          Prindi terve kataloog
        </a>
        <div className="subMenu">
          <span>Prindi üks kategooria</span>
          <ul>{this.createCategoryPrintButtons()}</ul>
        </div>

        <button
          disabled={bucketLength > 0 ? false : true}
          onClick={() => this.handleClickRequest()}
        >
          saada päring valitud toodete kohta{" "}
          {bucketLength > 0 && `(${bucketLength})`}
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, { setPopup, setMenuState })(MainMenu);
